module.exports = __webpack_public_path__ + "static/media/schuylkill-center-for-environmental-education.46a76013.md";